import { ConsumptionProfile } from '@customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const heatingScheduleSuccessMessageToPhraseKey: Partial<EnumDictionary<ConsumptionProfile, string>> = {
    [ConsumptionProfile.DayAndNocturnalFall]: 'HEATLOAD.HEATING_DISTRIBUTION.SUCCESS_MESSAGE.HEAT_WITH_DAY_AND_NOCTURNAL_FALL',
    [ConsumptionProfile.HeatPump]: 'HEATLOAD.HEATING_DISTRIBUTION.SUCCESS_MESSAGE.HEATPUMP_MODE',
    [ConsumptionProfile.NocturnalFall]: 'HEATLOAD.HEATING_DISTRIBUTION.SUCCESS_MESSAGE.HEAT_WITH_NOCTURNAL_FALL'
};
